import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IGroupsChangesState {
  isLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
  attentionESDPGroup: boolean;
  telegramGroup: {
    isLoading: boolean;
    success: boolean;
    errors: IFormErrors | null;
  };
}

export const initialGroupsChangesState: IGroupsChangesState = {
  isLoading: false,
  success: false,
  errors: null,
  attentionESDPGroup: false,
  telegramGroup: {
    isLoading: false,
    success: false,
    errors: null,
  },
};
